<template >

    <div class="data-table-acuerdo-clientes-base w-100 overflow-auto">

      <!-- Contenido de la tabla -->
      <div :class="load ? 'd-block w-100' : 'd-none'">
        <Loading />
      </div>
      <div :class="load ? 'd-none' : 'd-block w-100'" >
        <table
          class="table w-100 table-bordered"
          :id="nombreTabla"
        >
      <!-- Headers -->
      <thead>
        <tr>
          <template v-if="customHeaders" class="table-header">
            <th
              v-for="(item, index_header) in headers"
              :key="index_header"
              style="font-size: 11px !important"
              >
              {{ item.title }}
            </th>
          </template>
        </tr>
      </thead>
          <tbody>
            


            <template >
              <tr v-for="(item,index) in data" :key="index">
                <td
                  style="text-align: center; font-size: 11px"
                  v-text="index + 1"
                ></td>
                <td  style="font-size: 11px !important">
                  <ui-select
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="listaClientesUsuarioActual"
                    style="font-size: 11px !important; width: 100px"
                    v-model="item.cliente_id"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>
                <td style="font-size: 11px !important">
                  <ui-select
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    style="font-size: 10px !important"
                    :options="navieras"
                    v-model="item.naviera"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td style="font-size: 11px !important">
                  {{ item.naviera_salida }}
                </td>

                <td  style="font-size: 11px !important">
                  <ui-select
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="puertos"
                    style="font-size: 10px !important"
                    v-model="item.pol"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td  style="font-size: 11px !important">
                  <ui-select
                    has-search
                    placeholder="Seleccionar"
                    style="font-size: 10px !important"
                    searchPlaceholder="Buscar"
                    :options="puertos"
                    v-model="item.pod"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td>
                  <date-picker
                    placeholder="Fecha"
                    type="date"
                    class="mb-3  input_fecha"
                    value-type="format"
                    v-model="item.from_date"
                    style="font-size: 11px !important"
                  />
                </td>
                <td>
                  <date-picker
                    placeholder="Fecha"
                    type="date"
                    class="mb-3  input_fecha"
                    value-type="format"
                    v-model="item.to_date"
                    style="font-size: 11px !important"
                  />
                </td>
                <td>
                  <date-picker
                    placeholder="Vigencia"
                    class="mb-3 input_fecha"
                    type="date"
                    value-type="format"
                    v-model="item.vigencia"
                  />

                </td>
                <td>
                  <input
                    placeholder="TT"
                    v-model="item.transit_time"
                    style="font-size: 11px !important; width: 40px;"
                    disabled
                  />

                </td>

                <td>
                  <input
                    placeholder="Pública (Venta)"
                    type="text"
                    v-mask="decimalMask"
                    v-model="item.public_value"
                    style="font-size: 10px !important; width: 40px;"
                    disabled

                  />

                </td>

                <td>
                  <input
                    placeholder="Neta (Costo)"
                    type="text"
                    v-mask="decimalMask"
                    v-model="item.neta"
                    style="font-size: 11px !important; width: 40px;"
                    disabled

                  />
                </td>

                <td>
                  <input
                    placeholder="Margen"
                    type="text"
                    v-mask="marginMask"
                    style="font-size: 11px !important; width: 40px;"
                    v-model="item.margin"
                  />

                </td>

                <td>
                  <input
                    v-model="item.neta_cliente"
                    type="text"
                    v-mask="decimalMask"
                    style="font-size: 11px !important; width: 40px;"
                    disabled
                  />
                </td>
                <td>
                    <input        
                      v-model="item.descuento"
                      type="text"
                      v-mask="decimalMask"
                      style="font-size: 11px !important; width: 40px;"
                      disabled
                    />
                </td>
                <td>
                  <ui-select
                    style="font-size: 9px !important; ; width: 100px"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    v-model="item.container_id"
                    :options="selectContainers"
                    :keys="{ value: 'id', label: 'code' }"
                  />
                </td>
                <td>
                  <ui-select
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    style="font-size: 9px !important"
                    :options="selectCommodities"
                    v-model="item.products_category_id"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>
                <td>
                  <ui-select

                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    style="font-size: 9px !important"
                    :options="selectAtmospheres"
                    v-model="item.atmosphere_id"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>
                <td>
                  <ui-select
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    style="font-size: 9px !important"
                    :options="filtroColdtreatment"
                    v-model="item.coldtreatment"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>
                <td>
                  <input
                    placeholder="FDE"
                    style="font-size: 11px !important; width: 40px;"
                    v-model="item.free_days_embark"
                    disabled
                  />

                </td>
                <td>
                  <input
                    placeholder="PGE"
                    style="font-size: 11px !important; width: 40px;"
                    v-model="item.plug_days_embark"
                    disabled

                  />

                </td>
                <td>
                  <input
                    placeholder="FDL"
                    style="font-size: 11px !important; width: 40px;"
                    v-model="item.free_days_land"
                    disabled

                  />

                </td>
                <td>
                  <input
                    placeholder="PDL"
                    style="font-size: 11px !important; width: 40px;"
                    v-model="item.plug_days_land"
                    disabled
                  />

                </td>
                <td >
                  <input
                      type="checkbox"
                      v-model="item.genset"
                      style="align-items: center;margin-left: 15px; height: 15px; width: 15px"
                    />
                </td>
                <td style="font-size: 11px !important">
                  {{ item.get_out }}
                </td>
                <td>
                  <textarea
                    rows=1
                    style="font-size: 11px !important"
                    class="desc-text-area"
                    placeholder="Comentarios"
                    v-model="item.comment"
                  />
                </td>
                <td>
                  <ui-select
                    has-search
                    style="font-size: 9px !important"
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="tipoContratos"
                    v-model="item.tipo_contrato_id.name"
                    :keys="{ value: 'id', label: 'name' }"
                    disabled

                  />
                </td>
                <td>
                  <marquee id="tariff-contract" behavior="" direction="left" width="100"  >
                    {{ item.tariff_contract.contrato }}
                  </marquee>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </template>
<script>

  import { mapState, mapActions } from "vuex";
  // Importación de Jquery
  import $ from "jquery";
  import DatePicker from "vue2-datepicker";
  import Loading from "../../common/loading.vue";
  import UiSelect from "keen-ui/src/UiSelect";
  import createNumberMask from "text-mask-addons/dist/createNumberMask";

  const decimalMask = createNumberMask({
    prefix: "",
    suffix: "",
    allowDecimal: true,
    requireDecimal: false,
    includeThousandsSeparator: false,
    decimalSymbol: ".",
    decimalLimit: 2,
    integerLimit: 6,
  });
  const marginMask = createNumberMask({
    prefix: "",
    suffix: "",
    allowDecimal: true,
    requireDecimal: false,
    includeThousandsSeparator: false,
    decimalSymbol: ".",
    decimalLimit: 2,
    integerLimit: 6,
    allowNegative: true
  });

export default {
    components: { DatePicker, Loading, UiSelect},
    // components: { UiTextbox },
    props: {
      check: Boolean, // Permite agregar un checkbox como primer elemento de la tabla, esta opción esta deshabilitada por defecto
      customHeaders: Boolean, // Permite asignar el ancho de cada cabecera mediante un array de configuración {title: '', width: ''}
      headers: Array, // Titulos para cabecera de la tabla
      data: Array, // Contenido o información que mostrara la tabla
      acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
      paginacion: Boolean, // Si la tabla tedra activa la opción de paginación, esta opción esta deshabilitada por defecto
      max: { type: Number, default: 10 }, // Numero de filas por cada pagina
      buscar: Boolean, // Filtrar filas, esta opción esta deshabilitada por defecto
      idtabla: {
        type: String,
        default: "id_generico",
      },
      filtroColdtreatment: {
        type: Array,
        default: () => [],
      },
      load: Boolean
    },
  
    data() {
      return {
        decimalMask,
        marginMask,
        loading: true,
        lang: {
          lengthMenu: "Display _MENU_ records per page",
          zeroRecords: "No se encontraron registros coincidentes",
          info: "Mostrando página _PAGE_ de _PAGES_",
          infoEmpty: "No hay registros disponibles",
          infoFiltered: "(filtrado de _MAX_ registros totales)",
          search: "Buscar",
          paginate: {
            first: "Primero",
            last: "Ultimo",
            next: "Siguiente",
            previous: "Anterior",
          },
          buttons: {
            colvis: "Seleccionar columnas",
          },
        },
        nombreTabla: "id_tabla_" + this.idtabla,
        dataAux: this.data,
        accionesAux: this.acciones,
        flagFormulario: false,
        options: [],
        selected: [],
        selectAll: false,
        filtroContainers: this.filtroContenedores,
        filtroTipoProductos: this.filtroCommodity,
        filtroAtmo: this.filtroAtmosferas,
      };
    },
    computed: {

      ...mapState([
      "contratos",
      "clientes",
      "navieras",
      "puertos",
      "atmosferas",
      "destinos",
      "commodity",
      "tipoContratos",
      "contenedores", 
      "estados",
      "listaClientesUsuarioActual"
      ]),
      ...mapState("lineas", [ "selectCommodities", "selectAtmospheres", "selectContainers" ]),
    },
    methods: {
        cambiarEstadoCheck(event, id) {
            let estado = event.target.checked;
            let accion = "fila_chekeada";
            this.filaChekeada({ id, estado, accion });
        },
        cambiaValorDescuento (index) {

            const descuento =  parseInt( this.data[index].public_value ) - parseInt( this.data[index].neta );
            this.data[index].descuento = ( descuento > 0 ) ? descuento : 0 ;
        },
  
        select() {
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.options) {
                    this.selected.push(this.options[i]);
                }
            }
        },

  
      updateCheckall: function () {
        if (this.options.length == this.selected.length) {
          this.selectAll = true;
        } else {
          this.selectAll = false;
        }
      },
  
      cambiarEstadoTodosCHECK() {
        console.log(this.dataAux);
  
        
      },
  
      // Acciones de Vuex
      ...mapActions(["ActionSetLoading"]),
  
      filaSeleccionada(id, accion) {
        this.seleccionar({ id, accion });
      },
  
      configuracionDatatable() {
        let me = this;
  
        $("#" + this.nombreTabla)
          .DataTable()
          .destroy();
  
        $("#" + me.nombreTabla)
          .DataTable({
            paging: this.paginacion,
            pageLength: this.max,
            searching: this.buscar,
            lengthChange: false,
            ordering: true,
            info: true,
            autoWidth: true,
            checkd: false,
            // buttons: [
            //   "colvis",
            //   {
            //     text: "Hooola",
            //     extend: "excel",
            //     title: "Diego",
            //     exportOptions: {
            //       columns: [0, 1, 2, 3, 4, 5],
            //     },
            //   },
            // ],
            language: me.lang,
          })
          .buttons()
          .container()
          .appendTo("#" + me.nombreTabla + "_wrapper .col-md-6:eq(0)");
  
        $(".exportar-tabla").click(() => {
          $("#" + me.nombreTabla)
            .DataTable()
            .buttons(2 - 1)
            .trigger();
        });
      },
    },
  
    mounted() {

    },
  
    watch: {
      data: function (_new) {
        let me = this;
        // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
        // valor a la variable data
        me.dataAux = _new;

      },
  
      acciones: function (_new) {
        if (_new) {
          this.accionesAux = _new;
        }
      },
  
      cambiarEstadoTodosCHECK: function (_new) {
        if (_new) {
          this.cambiarEstadoTodosCHECK = _new;
        }
      },
    },
  };
  </script>
  
<style >
  .table-header {
    display: flex;
    flex-direction: row;
  }

  .input_fecha {
    width: 110px;
  }


  .desc-text-area {
    width: 10rem;
  }

#tableAcuerdosClientesBase .ui-modal__container {
    width: 91% !important;
}

.mx-datepicker {
    margin-left: 0px; 
}
  
.hide-button-excel {
    display: none;
  }
  
  .buttons-colvis {
    background-color: #dc3545;
    color: #ffff;
    padding: 6px;
    border: none;
    border-radius: 3px;
    font-size: 15px;
  }
  
  .buttons-colvis:hover {
    background-color: #bd2130;
    border: none;
  }
  
  div.dataTables_wrapper div.dataTables_info {
    font-size: 13px !important;
  }
  
  .icono {
    opacity: 0.7;
  }
  
  .icono:hover {
    opacity: 1;
  }
  
  .btn-group-sm > .btn,
  .btn-sm {
    padding: 0.25rem 0.45rem !important;
  }
  
  /* Table compact */

  
  
  table.dataTable.compact thead th,
  table.dataTable.compact thead td {
    padding: 3px 5px;
  }
  table.dataTable.compact tfoot th,
  table.dataTable.compact tfoot td {
    padding: 3px;
  }
  table.dataTable.compact tbody th,
  table.dataTable.compact tbody td {
    padding: 3px;
  }
  
  /* Table Hover */
  
  table.dataTable.hover > tbody > tr:hover > * {
    box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.087) !important;
  }
  
  /* Stripe (Pintado de tabla estilo cebra) */
  
  table.dataTable.stripe > tbody > tr.odd > *,
  table.dataTable.display > tbody > tr.odd > * {
    box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.048);
  }
  
  /*  */
  
  table.dataTable thead > tr > th.sorting,
  table.dataTable thead > tr > th.sorting_asc,
  table.dataTable thead > tr > th.sorting_desc,
  table.dataTable thead > tr > th.sorting_asc_disabled,
  table.dataTable thead > tr > th.sorting_desc_disabled,
  table.dataTable thead > tr > td.sorting,
  table.dataTable thead > tr > td.sorting_asc,
  table.dataTable thead > tr > td.sorting_desc,
  table.dataTable thead > tr > td.sorting_asc_disabled,
  table.dataTable thead > tr > td.sorting_desc_disabled {
    cursor: pointer;
    position: relative;
    padding: 10px 0 !important;
    text-align: center;
  }

    .data-table-acuerdo-clientes-base {
      /* border: 1px solid red; */
      height: 60vh;
      width: 100%;
      overflow: scroll;  
    }
/* 
  .data-table-acuerdo-clientes-base::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    cursor: pointer;
  }

  .data-table-acuerdo-clientes-base::-webkit-scrollbar-track {
    background: #ffffff;
  } */
/* 
  .data-table-acuerdo-clientes-base::-webkit-scrollbar-thumb {
    background: #cf2e2e;
    border-radius: 7px;
    cursor: pointer;
  } */
</style>
  